class TurnkeyActivityError extends Error {
    constructor(input) {
        const { message, cause, activityId, activityStatus, activityType } = input;
        super(message);
        this.name = "TurnkeyActivityError";
        this.activityId = activityId ?? null;
        this.activityStatus = activityStatus ?? null;
        this.activityType = activityType ?? null;
        this.cause = cause ?? null;
    }
}

export { TurnkeyActivityError };
//# sourceMappingURL=shared.mjs.map
